
import { Stage } from '../../../../react-konva';
import styled from 'styled-components';

const CanvasContainer = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  min-height: 0;
  background: ${({ theme }) => theme.palette['bg-primary']};
  overflow: hidden;
  flex: 1 1 auto;
`;

const StyledOrignalImage = styled.img`
  max-width: 98%;
  max-height: 98%;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const StyledCanvasNode = styled(Stage)`
  outline: none;
  background: ${({ theme }) => theme.palette['bg-secondary']};
`;

export { CanvasContainer, StyledOrignalImage, StyledCanvasNode };
